import { request } from "@/utils/request";
import store from "@/store";

/**
 * 登录
 * @param {*} phoneNumber
 * @param {*} verCode
 * @returns
 */
export async function login(data) {
  const resp = await request({
    url: "/admin/sup/login",
    method: "POST",
    data,
    // isEncrypt:false, //是否加密
    // isDecrypt: false, //是否解密
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
  });
  // var token = resp.headers.authorization;
  // var storeToken = resp.data.data;
  // 拿到服务器的令牌authorization
  // if (storeToken) {
  //   localStorage.setItem("storeToken", JSON.stringify(storeToken));
  // }
  if (resp.code === 200) {
    // 模拟生成token
    localStorage.setItem("storeToken", resp.data);
    // this.$store.commit("updataUserInfo", resp.data);
    // localStorage.setItem("userInfo", JSON.stringify(resp.data));
  }
  return resp;
}

/**
 * 手机号验证码登录
 * @param {*} data
 * @returns
 */
export async function loginByCode(data) {
  const resp = await request({
    url: "/admin/sup/loginByCode",
    method: "POST",
    data,
  });

  if (resp.code === 200) {
    localStorage.setItem("storeToken", resp.data);
  }
  return resp;
}

/**
 * 发送登录验证码
 * @param {*} data
 * @returns
 */
export function sendLoginCode(data) {
  return request({
    url: "/admin/sup/getCode",
    method: "POST",
    data,
  });
}

/**
 * 使用保存的令牌从服务器换取登录信息
 * @returns
 */
export async function queryMyselfInfo(data) {
  const storeToken = localStorage.getItem("storeToken");
  return request({
    url: "/admin/sup/queryMyselfInfo",
    method: "POST",
    data: {
      token: storeToken,
    },
  });
}

/* 注销登录 */
export function loginOut(data) {
  const resp = request({
    url: "/admin/sup/loginOut",
    method: "POST",
    data,
  });
  localStorage.removeItem("storeToken"); //用户token
  store.commit("updataUserInfo", {}); //清除仓库信息
  store.commit("updataFilterNavList", []); //清除菜单信息
  return resp;
}
